/**
 * The shared "not published yet" state (OBS49 rule: "a panel whose data
 * source is not yet published renders an explicit, styled 'not published
 * yet' state, which is a real state, not a stub"). Every panel that reads
 * an optional snapshot key (`layout`, `taxonomy`, `performance`, `life`,
 * `family`, `fleet.json`, the OBS-5 market-view contract) renders this
 * instead of crashing, guessing, or silently rendering nothing.
 */

export function renderNotPublishedYet(
  subject: string,
  detail: string,
  /** The badge text — a REAL empty state (a flat book) says what it is, not
   * "not published yet" (OQA). */
  badgeText = "not published yet",
): HTMLDivElement {
  const el = document.createElement("div");
  el.className = "obs-not-published";
  const badge = document.createElement("div");
  badge.className = "obs-badge";
  badge.textContent = badgeText;
  const title = document.createElement("div");
  title.textContent = subject;
  title.style.fontWeight = "600";
  const detailEl = document.createElement("div");
  detailEl.textContent = detail;
  detailEl.style.maxWidth = "320px";
  el.appendChild(badge);
  el.appendChild(title);
  el.appendChild(detailEl);
  return el;
}
